import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { isNullOrEmpty } from '../utils/common-functions';

@Injectable({
  providedIn: 'root',
})
export class ElementControlService {
  static elementControlConfig: any = {};
  getElementControlJSON$: BehaviorSubject<any | null> = new BehaviorSubject<
    any | null
  >(null);


  constructor() {}

  /**
   * 是否有該元素控制設定
   *
   * @param {string} category 分類
   * @param {string} elementId 元素 ID
   * @return {*}  {boolean}
   * @memberof ElementControlService
   */
  checkIsUnderControl(category: string, elementId: string,type: boolean = true): boolean {
    if (isNullOrEmpty(category) === false) {
      if (
        isNullOrEmpty(ElementControlService.elementControlConfig) === false &&
        ElementControlService.elementControlConfig.hasOwnProperty(category)
      ) {
        const config = ElementControlService.elementControlConfig[category];
        if (
          config.hasOwnProperty(elementId) &&
          config[elementId].display === type
        ) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * 取得元素控制設定
   *
   * @param {string} category 分類
   * @param {string} elementId 元素 ID
   * @return {*}  {*}
   * @memberof ElementControlService
   */
  getControlItem(category: string, elementId: string, type: boolean = true): any {
    if (this.checkIsUnderControl(category, elementId,type)) {
      const item =
        ElementControlService.elementControlConfig[category][elementId];
      return item;
    }
    return null;
  }

  getElementControl(): Observable<any | null> {
    return this.getElementControlJSON$.asObservable();
  }
}
